module.exports = __webpack_public_path__ + "static/media/THREE.e8de232d.png";